var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUsWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633.08 1325.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11{fill:#fff;}.cls-1,.cls-2{stroke:#d8baa3;}.cls-1,.cls-12,.cls-13,.cls-2,.cls-8{stroke-miterlimit:10;}.cls-1,.cls-12,.cls-2{stroke-width:6px;}.cls-12,.cls-13,.cls-2,.cls-8{fill:none;}.cls-3{fill:#b65a18;}.cls-4{fill:#642648;}.cls-5{fill:#c36f0b;}.cls-6{fill:#722d54;}.cls-7{fill:#3f4d90;}.cls-10,.cls-8{stroke:#fff;}.cls-8{stroke-width:4px;}.cls-10,.cls-9{fill:#f0e1d4;}.cls-10,.cls-11{stroke-linejoin:round;stroke-width:5px;}.cls-11{stroke:#3f4d79;}.cls-12,.cls-13{stroke:#722d54;}.cls-13{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.16,
    y: 817.11,
    width: 369.75,
    height: 79.24,
    rx: 39.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.07,1322.74h0a2.42,2.42,0,0,1-2.45-2.71l59.62-423.68H353.52L104.23,1321.53A2.49,2.49,0,0,1,102.07,1322.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.64,1322.74h0a2.4,2.4,0,0,0,2.43-2.74L354.52,896.35H160.24l259.28,425.22A2.49,2.49,0,0,0,421.64,1322.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WOMAN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_FOOT",
    "data-name": "RIGHT FOOT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.07,1163.3c13.48,1.34,35.3,4,61.33,1.53-6.68,25.78-9.75,50.43-14.61,72.33-3.14,14.1,16,33.19,21.8,47a4.69,4.69,0,0,0-.45-.21c-26.54-4.23-62.08,20.87-58.42-18.31C499.23,1226.42,490.4,1197.65,486.07,1163.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHOE",
    className: "cls-4",
    d: "M496.52,1236.8c-9.13,0-25.94,16.49-24.47,42.89a207,207,0,0,0,7.68,46h106.5c5-37.73-32.09-41.8-32.09-41.8-26.55-4.23-60.75,20.87-57.09-18.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_FOOT",
    "data-name": "LEFT FOOT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M412.07,1164.3c13.48,1.34,42.3,3,68.33.53-6.68,25.78-10.61,72.33-10.61,72.33-3.14,14.1,16,33.19,21.8,47a4.69,4.69,0,0,0-.45-.21c-26.54-4.23-62.08,20.87-58.42-18.31C436.23,1226.42,412.07,1164.3,412.07,1164.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHOE-2",
    "data-name": "SHOE",
    className: "cls-6",
    d: "M431.52,1236.8c-9.13,0-23.94,16.49-22.47,42.89a207,207,0,0,0,7.68,46h106.5c5-37.73-32.09-41.8-32.09-41.8-26.55-4.23-60.75,20.87-57.09-18.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEGS-2",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.07,595.93s-91.51,110.75-85,184.61,82.37,95.7,222,94.07c0,0,4.09,110.79,76.6,290,0,0,33.65,6.5,75,0,0,0,35,3.53,61-.17,0,0,55.44-362.35,48.7-399.1-8.93-48.7-185.4-92.63-231.08-103.18L327.1,595.93S250.42,605.67,198.07,595.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M300.64,705S447,743.4,464.87,790.47s18.78,378.14,18.78,378.14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BLOUSE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.63,457.34s-5.68,79.13-47.9,138.78c0,0-69,11.77-129,0,0,0-59.45-62.52-76.49-130.28,0,0-56.61-114.82-31-134.3s89.33-53,89.33-53l129.61,6.36c16,9.72,50.11,25.61,84.2,43.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 269.6,
    cy: 421.72,
    r: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 269.6,
    cy: 459.56,
    r: 9.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 269.6,
    cy: 497.39,
    r: 9.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND",
    "data-name": "RIGHT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M393.3,328.35c34.08,17.86,134.36,247.7,92.63,272-86.66,50.53-111.3-143-111.3-143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.47,607.52c11.7,5,41.89-4.21,75.44-26.19s-4.51-36.49-4.51-36.49-44.6-17.9-71.81-5S427.06,597.87,449.47,607.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "630.58 495.39 447.4 495.39 246.4 626.96 429.57 626.96 630.58 495.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.85,549.67c0-4.78-30.38-32.9-42-22.28-4.87,4.44-5.15,42.57-4.7,49.45C517.57,598.74,562.6,574.19,562.85,549.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND",
    "data-name": "LEFT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.16,331.54c-10.41,8.26-120.93,176.52-81.82,254C52.46,673,231.7,600.38,231.7,600.38s-22.74-7-8.13-36.22c0,0-74.16-39.46-133.81-27.69,0,0,46.26-76.7,51.13-106.73S127.5,301.92,90.16,331.54Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 270.44,
    y1: 512.96,
    x2: 303.1,
    y2: 585.91
  }), /*#__PURE__*/React.createElement("g", {
    id: "ARM"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.62,561.82s32.87-18.74,46-11.72c14.39,7.68,31.65,32,33.23,36.09s1.13,8.34.88,12.72-30,4.13-35.72,3.8-36.42,3.31-41.78-1.94C206.56,581.51,223.62,561.82,223.62,561.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268,602.71c5.76.33,32.06.66,35.41-2.46,6.65-6.17,2.84-15.39-.49-19-3.05-3.32-19.28-23.47-33.31-31.12,0,0,16.27,28.31-1.61,52.61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.93,67.77s-14.61-23.54,0-35.71S234.55.13,261,0c27.32-.13,38.22,21.17,50.73,19.07,17-2.85,28.92-8.33,50.51,3.06,17.28,9.12,18,43.31,35.52,41.58,13.94-1.37,29.42-.49,37.33,15,6,11.73-.4,43.42,8.52,51.94s30,11.3,31.66,33.27c2.2,29.69-28.8,34.06-20.7,57.63,10.66,31-4.38,50.46-30.84,54-18.61,2.47-51.31-25.2-63.3-6.09-10.23,16.29-31.66,23.54-58,13s-42.61-7.31-58.84-.41-36.12,16.63-49.51,4.86-29.55-12.1-47.38-4.73c-24.74,10.23-51.29-6.59-48-28.94,2.73-18.47-22.62-20.8-25.56-41.8-3.84-27.43,36.52-34.49,24.75-46.26S86.54,119,121.41,114.44c33.08-4.3,26-24.91,35.33-39C164.61,63.66,189.18,48.7,213.93,67.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M83.72,158.72c-11-12.46-7.49-50.8,27.59-53.19,33.28-2.26,27.46-23.27,37.65-36.72C157.54,57.5,186.3,44,213.52,67.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.65,168.93c-.25,21,1.06,78.91-39.16,109.6,0,0,72.22,36.27,88.52,116.62,0,0,11.47-84.69,41.09-110.26,0,0-35.1-19.9-27.39-116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.32,252.15c-5,4.52-10.64,7.1-16.76,7.1-25.34,0-50.57-38.6-53-79.87.08-4.06.08-7.6.12-10.45h63.06C278.57,208,282.52,234.49,288.32,252.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HEAD-2",
    "data-name": "HEAD",
    className: "cls-5",
    d: "M216.37,149.93c.28-10.56,4-65.74,48.69-63.71S317,133.29,313,169.41s-26,60.46-41.39,58.84S215.15,194.57,216.37,149.93Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsWriting);
export default __webpack_public_path__ + "static/media/contact-us-writing.ee6b680beca47b3abc2f8d0f67d22ce8.svg";
export { ForwardRef as ReactComponent };